
export const StateList = [
    { "name": "-", "code": "00"},
    { "name": "dolnośląskie", "code": "824"},
    { "name": "lubelskie", "code": "826"},
    { "name": "kujawsko-pomorskie", "code": "825"},
    { "name": "lubuskie", "code": "828"},
    { "name": "mazowieckie","code": "830" },
    { "name": "małopolskie","code": "829"},
    { "name": "opolskie","code": "831"},
    { "name": "podkarpackie", "code": "832"},
    { "name": "podlaskie", "code": "833"},
    { "name": "pomorskie", "code": "834"},
    { "name": "warmińsko-mazurskie", "code": "837"},
    { "name": "wielkopolskie", "code": "838"},
    { "name": "zachodnipomorskie", "code": "839"},
    { "name": "łódzkie", "code": "828"},
    { "name": "śląskie", "code": "835"},
    { "name": "świętokrzyskie", "code": "836"},
]
export default  [
    { text: "-", value: "00"},
    { text: "dolnośląskie", value: "02"},
    { text: "kujawsko-pomorskie", value: "04"},
    { text: "lubelskie", value: "06"},
    { text: "lubuskie", value: "08"},
    { text: "mazowieckie",value: "14" },
    { text: "małopolskie",value: "12"},
    { text: "opolskie",value: "16"},
    { text: "podkarpackie", value: "18"},
    { text: "podlaskie", value: "20"},
    { text: "pomorskie", value: "22"},
    { text: "warmińsko-mazurskie", value: "28"},
    { text: "wielkopolskie", value: "30"},
    { text: "zachodnipomorskie", value: "32 "},
    { text: "łódzkie", value: "10 "},
    { text: "śląskie", value: "24 "},
    { text: "świętokrzyskie", value: "26"},
]